// extracted by mini-css-extract-plugin
module.exports = {"link":"nV2U7VZp"};